<!--
  Client Portal: Add New Order (/portal/orders/new).

  Card: Rename "Admin Buyer" to Client Portal and retire the legacy Admin
  Buyer dashboard (Bug Intake #566, https://trello.com/c/9R4TXtuz). A Client
  Admin holds `order.create` and placed staff orders from the legacy
  dashboard; that dashboard is deleted and the same flow (NewOrderFlow ->
  AddOrder) lives here. The route requires portal.access AND order.create,
  so a Store Manager is never offered it.

  The stores offered are the caller's portal stores (usePortalScopeStore,
  loaded by PortalLayout from GET /api/portal/stores -- the server's list for
  this caller). The header scope's store, when one is selected, is the
  starting store.
-->
<template>
  <v-container fluid class="portal-new-order" data-testid="portal-page-new-order">
    <router-link
      :to="{ name: 'portal_orders' }"
      class="portal-new-order__back text-body-2"
      data-testid="portal-new-order-back"
    >
      Back to Orders
    </router-link>
    <h1 class="text-h5 mb-1">Add New Order</h1>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Place an order for a shopper in one of your stores.
    </p>

    <NewOrderFlow
      :stores="scope.stores"
      :stores-loading="!scope.loaded"
      :initial-store-id="scope.selectedStoreId"
      @exit="backToOrders"
    />
  </v-container>
</template>

<script>
import NewOrderFlow from "@/components/Order/NewOrderFlow.vue";
import { usePortalScopeStore } from "@/stores/portalScope";

export default {
  name: "PortalNewOrder",
  components: { NewOrderFlow },
  setup() {
    const scope = usePortalScopeStore();
    return { scope };
  },
  methods: {
    backToOrders() {
      this.$router.push({ name: "portal_orders" });
    },
  },
};
</script>

<style scoped>
.portal-new-order__back {
  display: inline-block;
  margin-bottom: var(--tf-sp-2, 8px);
  color: inherit;
}
</style>
